import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Agenda\GetEventByIdController::__invoke
* @see app/Http/Controllers/Agenda/GetEventByIdController.php
* @route '/api/agenda/event/{event}'
*/
const GetEventByIdController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetEventByIdController.url(args, options),
    method: 'get',
})

GetEventByIdController.definition = {
    methods: ["get","head"],
    url: '/api/agenda/event/{event}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Agenda\GetEventByIdController::__invoke
* @see app/Http/Controllers/Agenda/GetEventByIdController.php
* @route '/api/agenda/event/{event}'
*/
GetEventByIdController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return GetEventByIdController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Agenda\GetEventByIdController::__invoke
* @see app/Http/Controllers/Agenda/GetEventByIdController.php
* @route '/api/agenda/event/{event}'
*/
GetEventByIdController.get = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetEventByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Agenda\GetEventByIdController::__invoke
* @see app/Http/Controllers/Agenda/GetEventByIdController.php
* @route '/api/agenda/event/{event}'
*/
GetEventByIdController.head = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetEventByIdController.url(args, options),
    method: 'head',
})

export default GetEventByIdController